import { Table, TableColumnsType } from "antd";
import _ from "lodash";
import moment from "moment";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { useTranslation } from 'react-i18next';
import config from "../../../lib/config";
import exportTitleTable from "../../../lib/exportTitleTable";
import { IExamStatsSummary } from "../../../models/statistics.model";
import DownloadButton from "../../DownloadButton";
import Pagination from "../../Pagination";

interface IProps {
  rawData: IExamStatsSummary[]|undefined;
  excelParam: {excelCampusCodes: string[]}|undefined;
}

const ExamStatsSummary: FC<IProps> = ({
  rawData,
  excelParam,
}) => {
  const { t } = useTranslation();
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const [data, setData] = useState<IExamStatsSummary[]>([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (rawData) {
      const _data: IExamStatsSummary[] = _.cloneDeep(rawData);

      if (rawData?.length) {
        _data.forEach((item: any, idx: number) => {
          item.rowIdx = idx;
        });
      }

      setData(_data);
    }
  } ,[rawData]);

  const onExportTable = () => {
    const currentDate = moment(new Date());

    let excelTitle = t('statistics.regularTest.5');
    let arrSubTitle = [];
    let campusNames = '';

    if(excelParam?.excelCampusCodes) {
      if(excelParam.excelCampusCodes.length === 0) {
        campusNames = t('common.text.all');
      } else {
        excelParam.excelCampusCodes.forEach((item) => {
          if(campusNames !== '') {
            campusNames += ', '  
          }
          campusNames += campusData.find(campus => item === campus.campusCode)?.campusKorName;
        });
      }
    }

    arrSubTitle.push(t('common.excel.campus') + " : " + campusNames);

    exportTitleTable(columns, data, `${t('statistics.regularTest.5')}_(${currentDate.format('YYYYMMDD')})`, t('statistics.regularTest.6'), [12, 30, 10, 12, 10, 10, 10, 12], excelTitle, arrSubTitle);
  }

  const columns: TableColumnsType<IExamStatsSummary> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusKorName',
      key: 'campusKorName',
      align: 'center',
    },
    {
      title: t('class.class.column3'),
      dataIndex: 'examName',
      key: 'examName',
      align: 'center',
    },
    {
      title: t('statistics.dttt.column2'),
      dataIndex: 'averageScore',
      key: 'averageScore',
      align: 'center',
      render: value => Math.round(value),
    },
    {
      title: t('statistics.placementTest.column1'),
      dataIndex: 'averageTimeRequired',
      key: 'averageTimeRequired',
      align: 'center',
      render: value => Math.round(value),
    },
    {
      title: t('statistics.placementTest.column2'),
      dataIndex: 'totalRequireCount',
      key: 'totalRequireCount',
      align: 'center',
    },
    {
      title: t('statistics.placementTest.column3'),
      dataIndex: 'participantCount',
      key: 'participantCount',
      align: 'center',
    },
    {
      title: t('statistics.placementTest.column4'),
      dataIndex: 'nonParticipantCount',
      key: 'nonParticipantCount',
      align: 'center',
    },
    {
      title: t('statistics.placementTest.column5'),
      dataIndex: 'participantRate',
      key: 'participantRate',
      align: 'center',
      render: value => Math.round(value),
    },
  ];

  return (
    <>
      <div className="comm-table__area">
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: page,
            pageSize: config.pageSize,
          }}
          rowKey={'rowIdx'}
          rowClassName={(record: IExamStatsSummary) => record.campusCode === '1' ? 'tfoot' : ''}
        />
      </div>
      <div className="comm-bx__between">
        <DownloadButton onClick={onExportTable} />
        <div className="common-paging center">
          <Pagination
            count={data.length}
            page={page}
            setPage={setPage}
          />
        </div>
      </div>
    </>
  );
}

export default ExamStatsSummary;
